import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const TripleIntegrationSpherical = () => (
  <QPhototModuleSubtopic
    title="Using spherical coordinates for triple integration"
    videos={[
      "https://www.youtube.com/embed/STs1CVJcQV4",
      "https://www.youtube.com/embed/S37r1pedR0M",
      "https://www.youtube.com/embed/UDGw-vzGbbE"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_52.jpeg"
        },
        {
            image:"/cal_53.jpeg"
        },
        {
            image:"/cal_54.jpeg"
        },
        {
            image:"/cal_55.jpeg"
        },
    ]}
    exampleVideos={[]}
  />
);

export default TripleIntegrationSpherical;
